import React from "react";
import { Container } from "../../../../components";
import { Heading, Text, Toggle } from "@telia/teddy";
import { connect } from "react-redux";
import { RootState } from "../../../../../../models";
import { FieldSet, FormRow, FormRowFormats, Input } from "../../../../forms";
import { VALIDATION_FIELD } from "../../../../rapidform/formValidation";
import { setShouldShowPBFields as setShouldShowPBFieldsAction } from "../../../state/actions/businessActions";
import * as BUSINESS_DETAILS_SELECTORS from "../../../state/selectors/businessDetailsSelectors";
import TEXT from "../../../text-consts-b2b";
import "./B2BDeliveryCard.less";

type TableItem = {
    key?: string;
    value?: string;
};

interface TableProps {
    items: TableItem[];
}

const Table: React.FC<TableProps> = ({ items }) => (
    <div className="b2b-delivery-card__table">
        {items.map((item, index) => (
            <div key={`table-item-${item.key}-${index}`} className="b2b-delivery-card__table-item">
                <span className="b2b-delivery-card__table-item-key">{item.key}</span>
                <span className="b2b-delivery-card__table-item-value">{item.value}</span>
            </div>
        ))}
    </div>
);

interface B2BDeliveryCardProps {
    isMbb?: boolean;
    setShouldShowPBFields: (value: boolean) => void;
    shouldShowPBFields?: boolean;
    tableItems: TableItem[];
    totalMonthlyPrice?: number;
    totalUpfrontPrice?: number;
}

const B2BDeliveryCard: React.FC<B2BDeliveryCardProps> = ({
    isMbb,
    shouldShowPBFields,
    setShouldShowPBFields,
    tableItems,
    totalUpfrontPrice,
    totalMonthlyPrice,
}) => {
    return (
        <Container className="b2b-order__section b2b-delivery-card" size="large" whiteBg>
            <Heading mb="100" as="h2" variant="title-300">
                {TEXT.B2B_MANUAL_ORDER.DELIVERY_CARD.HEADING}
            </Heading>
            <Heading mb="100" as="h3" variant="title-100">
                {TEXT.B2B_MANUAL_ORDER.DELIVERY_CARD.DELIVERY}
            </Heading>
            <FieldSet name="manualOrder" noMargin>
                <div className="b2b-delivery-card__toggle-container">
                    <Toggle>
                        <Toggle.Input
                            checked={!!shouldShowPBFields}
                            onCheckedChange={() => setShouldShowPBFields(!shouldShowPBFields)}
                        />
                        <Toggle.Label>{TEXT.PERSONAL_DETAILS.USE_POST_BOX}</Toggle.Label>
                    </Toggle>
                </div>
                <FormRow format={FormRowFormats.TWENTY_FIVE} data-di-mask>
                    {shouldShowPBFields && (
                        <>
                            <Input
                                type="text"
                                name={VALIDATION_FIELD.PB_NUMBER}
                                label={TEXT.PERSONAL_DETAILS.PB_NUMBER}
                            />
                            <Input
                                type="text"
                                name={VALIDATION_FIELD.PB_NAME}
                                label={TEXT.PERSONAL_DETAILS.PB_NAME}
                                helpText={TEXT.PERSONAL_DETAILS.PB_NAME_HELPTEXT}
                            />
                        </>
                    )}
                    {!shouldShowPBFields && (
                        <>
                            <Input
                                type="text"
                                name={VALIDATION_FIELD.STREET_CO}
                                label={TEXT.PERSONAL_DETAILS.STREET_CO}
                                helpText={TEXT.PERSONAL_DETAILS.STREET_CO_HELPTEXT}
                            />
                            <Input type="text" name={VALIDATION_FIELD.STREET} label={TEXT.PERSONAL_DETAILS.STREET} />
                        </>
                    )}
                    <Input type="text" name={VALIDATION_FIELD.POSTCODE} label={TEXT.PERSONAL_DETAILS.POSTCODE} />
                    <Input type="text" name={VALIDATION_FIELD.CITY} label={TEXT.PERSONAL_DETAILS.CITY} />
                </FormRow>
                <Text mb="100" className="b2b-delivery-card__paragraph" variant="additional-100">
                    {TEXT.B2B_MANUAL_ORDER.DELIVERY_CARD.DELIVERY_DESCRIPTION}
                </Text>
                <Heading mb="100" as="h3" variant="title-100">
                    {TEXT.B2B_MANUAL_ORDER.DELIVERY_CARD.EMAIL_INVOICE}
                </Heading>
                <Input
                    type="text"
                    className="b2b-delivery-card__single-input"
                    name={VALIDATION_FIELD.EMAIL}
                    label=""
                    data-di-mask
                />
            </FieldSet>
            <Heading mb="100" as="h3" variant="title-100">
                {TEXT.B2B_MANUAL_ORDER.DELIVERY_CARD.SUMMARY}
            </Heading>
            <Table items={tableItems} />
            {totalMonthlyPrice && (
                <div className="b2b-delivery-card__price-summary">
                    <span className="b2b-delivery-card__price-summary-item">
                        {TEXT.B2B_MANUAL_ORDER.DELIVERY_CARD.MONTHLY_COST_LABEL} {totalMonthlyPrice},-/md
                    </span>
                    {isMbb && totalUpfrontPrice && (
                        <span className="b2b-delivery-card__price-summary-item">
                            {TEXT.B2B_MANUAL_ORDER.DELIVERY_CARD.UPFRONT_COST_LABEL} {totalUpfrontPrice},-
                        </span>
                    )}
                </div>
            )}
        </Container>
    );
};

const mapStateToProps = (state: RootState) => ({
    shouldShowPBFields: BUSINESS_DETAILS_SELECTORS.shouldShowPBFields(state),
});

export default connect(mapStateToProps, {
    setShouldShowPBFields: setShouldShowPBFieldsAction,
})(B2BDeliveryCard);
